import React, { useState } from "react";
import Select from "../../Common/FormElements/Select/Select";
import TextInput from "../../Common/FormElements/TextInput/TextInput";
import { useTranslation } from "react-i18next";

const Storekeeper = ({
  el,
  index,
  storekeeper,
  getSelectValue,
  handleChange,
}) => {
  const { t } = useTranslation("common");
  const [errors, setErrors] = useState({});

  const getValue = (fieldName) => {
    if (el.userField) {
      return storekeeper.user?.[fieldName] || "";
    }
    return storekeeper[fieldName] || "";
  };

  const validateField = (element, value) => {
    if (element.required && (!value || value.trim() === "")) {
      return `${t(element.label)} ${t("is required")}`;
    }

    if (element.type === "email" && value) {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(value)) {
        return `${t(element.label)} ${t("must be a valid email")}`;
      }
    }

    return null;
  };

  return (
    <div className="col-6" key={el?.name}>
      <p className="f16 text-ultraBlack mb-2">
        {t(`${el?.label}`)}
        {el.required && <span className="text-danger">*</span>}
      </p>
      {el.type === "select" ? (
        <Select
          {...el}
          label={el.label ? t(`${el.label}`) : ""}
          placeholder={el.placeholder ? t(`${el.placeholder}`) : ""}
          value={getSelectValue(getValue(el?.name), el.options ?? [])}
          options={(el.options ?? []).map((option) => ({
            name: t(`${option.name}`),
            code: option.code,
          }))}
          callback={handleChange(index)}
          appendToSelf
        />
      ) : (
        <TextInput
          {...el}
          label={el.label ? t(`${el.label}`) : ""}
          placeholder={el.placeholder ? t(`${el.placeholder}`) : ""}
          value={getValue(el?.name)}
          callback={handleChange(index)}
          disabled={el?.disabled}
          onBlur={(e) => {
            const error = validateField(el, e.target.value);
            if (error) {
              setErrors((prev) => ({
                ...prev,
                [el.name]: error,
              }));
            }
          }}
          className={errors[el.name] ? "border-danger" : ""}
        />
      )}
    </div>
  );
};

export default Storekeeper;
